(() => {
  const RETURN_PATH = "/account";

  function openLoginPopup() {
    const popup = document.querySelector("[data-login-popup]");
    if (!popup) return;

    popup.hidden = false;
    document.documentElement.classList.add("login-popup-open");
    document.body.classList.add("login-popup-open");
  }

  function closeLoginPopup() {
    const popup = document.querySelector("[data-login-popup]");
    if (!popup) return;

    popup.hidden = true;
    document.documentElement.classList.remove("login-popup-open");
    document.body.classList.remove("login-popup-open");
  }

  function switchTab(tabName) {
    const popup = document.querySelector("[data-login-popup]");
    if (!popup) return;

    const tabs = popup.querySelectorAll("[data-login-tab]");
    const panels = popup.querySelectorAll("[data-login-panel]");

    tabs.forEach((t) => {
      t.classList.toggle("is-active", t.getAttribute("data-login-tab") === tabName);
    });

    panels.forEach((p) => {
      const isTarget = p.getAttribute("data-login-panel") === tabName;
      p.style.display = isTarget ? "block" : "none";
    });

    setTimeout(() => {
      if (tabName === "login") {
        const emailInput = popup.querySelector('#customer\\[email\\]_popup');
        if (emailInput) emailInput.focus();
      } else {
        const emailInput = popup.querySelector('#customer\\[email\\]_register_popup');
        if (emailInput) emailInput.focus();
      }
    }, 10);

    if (tabName === "register") {
      setTimeout(() => {
        bindRegisterSocialProtection();
        bindRegisterSubmitProtection();
      }, 0);
    }
  }

  function ensureConsentErrorBox(registerPanel) {
    if (!registerPanel) return null;

    const existing = registerPanel.querySelector(".rsport-consent-error");
    if (existing) return existing;

    const wrap = registerPanel.querySelector(".h_register_consents");
    if (!wrap) return null;

    const error = document.createElement("div");
    error.className = "rsport-consent-error";
    error.style.display = "none";
    error.textContent = "כדי להירשם חייבים לאשר את תנאי השימוש ומדיניות הפרטיות";

    wrap.appendChild(error);
    return error;
  }

  function getTermsCheckbox(registerPanel) {
    if (!registerPanel) return null;
    return registerPanel.querySelector("#customer_terms_approved_popup");
  }

  function showConsentError(registerPanel) {
    const error = ensureConsentErrorBox(registerPanel);
    if (error) error.style.display = "block";
  }

  function hideConsentError(registerPanel) {
    const error = ensureConsentErrorBox(registerPanel);
    if (error) error.style.display = "none";
  }

  function bindRegisterSubmitProtection() {
    const popup = document.querySelector("[data-login-popup]");
    if (!popup) return;

    const registerPanel = popup.querySelector('[data-login-panel="register"]');
    if (!registerPanel) return;

    const registerForm = registerPanel.querySelector("form");
    if (!registerForm) return;

    if (registerForm.dataset.rsportSubmitBound === "1") return;
    registerForm.dataset.rsportSubmitBound = "1";

    registerForm.addEventListener("submit", (e) => {
      const terms = getTermsCheckbox(registerPanel);
      if (!terms) return;

      if (!terms.checked) {
        e.preventDefault();
        showConsentError(registerPanel);
        terms.focus({ preventScroll: false });
        return;
      }

      hideConsentError(registerPanel);
    });

    const terms = getTermsCheckbox(registerPanel);
    if (terms && terms.dataset.rsportChangeBound !== "1") {
      terms.dataset.rsportChangeBound = "1";

      terms.addEventListener("change", () => {
        if (terms.checked) hideConsentError(registerPanel);
      });
    }
  }

  function bindRegisterSocialProtection() {
    const popup = document.querySelector("[data-login-popup]");
    if (!popup) return;

    const registerPanel = popup.querySelector('[data-login-panel="register"]');
    if (!registerPanel) return;

    const terms = getTermsCheckbox(registerPanel);
    if (!terms) return;

    const wizard = registerPanel.querySelector(".h_wizard");
    if (!wizard) return;

    if (wizard.dataset.rsportWizardBound === "1") return;
    wizard.dataset.rsportWizardBound = "1";

    wizard.addEventListener("click", (e) => {
      const btn = e.target.closest(".h_buttons > div");
      if (!btn) return;

      if (!terms.checked) {
        e.preventDefault();
        e.stopPropagation();
        showConsentError(registerPanel);
        terms.focus({ preventScroll: false });
        return false;
      }

      hideConsentError(registerPanel);
    }, true);

    // אם האפליקציה מאזינה לאירועים אחרים כמו pointerdown
    wizard.addEventListener("pointerdown", (e) => {
      const btn = e.target.closest(".h_buttons > div");
      if (!btn) return;

      if (!terms.checked) {
        e.preventDefault();
        e.stopPropagation();
        showConsentError(registerPanel);
        return false;
      }
    }, true);
  }

  function observeHikoInjection() {
    const popup = document.querySelector("[data-login-popup]");
    if (!popup) return;

    const registerPanel = popup.querySelector('[data-login-panel="register"]');
    if (!registerPanel) return;

    const observer = new MutationObserver(() => {
      bindRegisterSocialProtection();
      bindRegisterSubmitProtection();
    });

    observer.observe(registerPanel, { childList: true, subtree: true });
  }

  function bindPopupEvents() {
    const popup = document.querySelector("[data-login-popup]");
    if (!popup) return;

    document.querySelectorAll("[data-login-popup-open]").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        openLoginPopup();
        switchTab("login");
      });
    });

    popup.querySelectorAll("[data-login-popup-close]").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        closeLoginPopup();
      });
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeLoginPopup();
    });

    popup.querySelectorAll("[data-login-tab]").forEach((tabBtn) => {
      tabBtn.addEventListener("click", () => {
        const tabName = tabBtn.getAttribute("data-login-tab");
        switchTab(tabName);
      });
    });
  }

  function init() {
    bindPopupEvents();
    observeHikoInjection();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
(() => {
  function initBirthDateLabel() {
    const input = document.querySelector('#customer\\[note\\]\\[birth_date\\]_register_popup');
    if (!input) return;

    const wrap = input.closest(".rsport-birthdate-field");
    if (!wrap) return;

    const label = wrap.querySelector(".rsport-birthdate-label");
    if (!label) return;

    const focusedLabel = "תאריך לידה";

    label.textContent = "";

    input.addEventListener("focus", () => {
      label.textContent = focusedLabel;
    });

    input.addEventListener("blur", () => {
      if (!input.value.trim()) {
        label.textContent = "";
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBirthDateLabel);
  } else {
    initBirthDateLabel();
  }
})();
(() => {
  function getPopup() {
    return document.querySelector("[data-login-popup]");
  }

  function getLoader() {
    const popup = getPopup();
    if (!popup) return null;
    return popup.querySelector("[data-rsport-auth-loading]");
  }

  function showLoader() {
    const loader = getLoader();
    if (!loader) return;
    loader.hidden = false;
  }

  function hideLoader() {
    const loader = getLoader();
    if (!loader) return;
    loader.hidden = true;
  }

  function isRegisterPanelActive(popup) {
    const registerPanel = popup.querySelector('[data-login-panel="register"]');
    if (!registerPanel) return false;
    return registerPanel.style.display !== "none";
  }

  function bindSubmitLoading() {
    const popup = getPopup();
    if (!popup) return;

    const loginForm = popup.querySelector('[data-login-panel="login"] form');
    const registerForm = popup.querySelector('[data-login-panel="register"] form');

    [loginForm, registerForm].forEach((form) => {
      if (!form) return;
      if (form.dataset.rsportLoadingBound === "1") return;
      form.dataset.rsportLoadingBound = "1";

      form.addEventListener("submit", () => {
        showLoader();
      });
    });

    // אם הדפדפן החזיר אחורה או שהעמוד נטען מחדש
    window.addEventListener("pageshow", () => {
      hideLoader();
    });
  }

  function bindSocialLoading() {
    const popup = getPopup();
    if (!popup) return;

    if (popup.dataset.rsportSocialLoadingBound === "1") return;
    popup.dataset.rsportSocialLoadingBound = "1";

    popup.addEventListener(
      "click",
      (e) => {
        const btn = e.target.closest(".h_wizard .h_buttons > div");
        if (!btn) return;

        // אם זה הרשמה, חייב תקנון לפני טעינה
        if (isRegisterPanelActive(popup)) {
          const terms = popup.querySelector("#customer_terms_approved_popup");
          if (terms && !terms.checked) return;
        }

        showLoader();
      },
      true
    );
  }

  function init() {
    bindSubmitLoading();
    bindSocialLoading();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
(() => {
  function bindBirthDateMask() {
    const input = document.querySelector('#customer\\[note\\]\\[birth_date\\]_register_popup');
    if (!input) return;

    if (input.dataset.rsportMaskBound === "1") return;
    input.dataset.rsportMaskBound = "1";

    input.addEventListener("input", () => {
      let v = input.value.replace(/\D/g, "").slice(0, 8);

      if (v.length >= 5) {
        input.value = v.slice(0, 2) + "/" + v.slice(2, 4) + "/" + v.slice(4);
      } else if (v.length >= 3) {
        input.value = v.slice(0, 2) + "/" + v.slice(2);
      } else {
        input.value = v;
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindBirthDateMask);
  } else {
    bindBirthDateMask();
  }
})();

(() => {
  function getPopup() {
    return document.querySelector("[data-login-popup]");
  }

  function getActiveTabName() {
    const popup = getPopup();
    if (!popup) return "login";

    const activeTab = popup.querySelector("[data-login-tab].is-active");
    if (!activeTab) return "login";

    return activeTab.getAttribute("data-login-tab") || "login";
  }

  function findWizard() {
    const popup = getPopup();
    if (!popup) return null;

    return popup.querySelector(".h_wizard");
  }

  function getSlotByTab(tabName) {
    const popup = getPopup();
    if (!popup) return null;

    if (tabName === "register") {
      return popup.querySelector(".rsport-social-slot--register");
    }

    return popup.querySelector(".rsport-social-slot--login");
  }

  function moveWizardToActiveTab() {
    const wizard = findWizard();
    if (!wizard) return;

    const tabName = getActiveTabName();
    const slot = getSlotByTab(tabName);
    if (!slot) return;

    if (wizard.parentElement !== slot) {
      slot.appendChild(wizard);
    }
  }

  function observePopupChanges() {
    const popup = getPopup();
    if (!popup) return;

    const observer = new MutationObserver(() => {
      moveWizardToActiveTab();
    });

    observer.observe(popup, { childList: true, subtree: true });
  }

  function bindTabSwitchEvents() {
    const popup = getPopup();
    if (!popup) return;

    popup.querySelectorAll("[data-login-tab]").forEach((btn) => {
      btn.addEventListener("click", () => {
        setTimeout(() => {
          moveWizardToActiveTab();
        }, 50);
      });
    });
  }

  function init() {
    moveWizardToActiveTab();
    observePopupChanges();
    bindTabSwitchEvents();

    // ביטוח נגד HIKO שמנסה "לברוח"
    setInterval(moveWizardToActiveTab, 400);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();


(() => {
  function applyHikoMobileGrid() {
    const popup = document.querySelector("[data-login-popup]");
    if (!popup) return;

    const wizards = popup.querySelectorAll(".h_wizard");
    if (!wizards.length) return;

    const isMobile = window.matchMedia("(max-width: 600px)").matches;

    wizards.forEach((wizard) => {
      const buttons = wizard.querySelector(".h_buttons");
      if (!buttons) return;

      if (isMobile) {
        // מוחק inline style שהתוסף שם
        buttons.removeAttribute("style");

        // מרכז את הכל ומקטין את הרוחב הכללי
        buttons.style.display = "grid";
        buttons.style.gridTemplateColumns = "repeat(2, minmax(0, 1fr))";
        buttons.style.gap = "2px"; // פחות רווח גם אנכי וגם רוחבי
        buttons.style.width = "100%"; // מקטין רוחב כללי
        buttons.style.margin = "0 auto"; // משאיר באמצע
        buttons.style.justifyContent = "center";

        // כל כפתור
        buttons.querySelectorAll(":scope > div").forEach((btn) => {
          btn.style.width = "100%";
          btn.style.height = "35px"; // קצת נמוך יותר
          btn.style.minHeight = "35px";
          btn.style.display = "flex";
          btn.style.alignItems = "center";
          btn.style.justifyContent = "center";
          btn.style.boxSizing = "border-box";
          btn.style.borderRadius = "10px";
        });
      } else {
        buttons.removeAttribute("style");
        buttons.querySelectorAll(":scope > div").forEach((btn) => {
          btn.removeAttribute("style");
        });
      }
    });
  }

  function observeHikoWizard() {
    const popup = document.querySelector("[data-login-popup]");
    if (!popup) return;

    const obs = new MutationObserver(() => {
      applyHikoMobileGrid();
    });

    obs.observe(popup, { childList: true, subtree: true });
  }

  function init() {
    applyHikoMobileGrid();
    observeHikoWizard();

    setInterval(applyHikoMobileGrid, 400);
    window.addEventListener("resize", applyHikoMobileGrid);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
